import user from '@motionelements/core/src/store/modules/user.js';
import * as accountApi from '@/api/account.js';

export default {
  namespaced: true,
  state: () => user.state,
  getters: {
    ...user.getters,
    hasSubscription(state) {
      return state.member.studioAiSubscriptionType === 'subscription';
    },
  },
  actions: {
    ...user.actions,
    setCoins({ commit }) {
      return accountApi.getCoinsBalance()
        .then((response) => {
          const coins = _.get(response, 'data.data.balance');
          const type = _.get(response, 'data.data.type');
          commit('setCoins', coins);
          commit('setSubscriptionType', type);
        });
    },
  },
  mutations: {
    ...user.mutations,
    setCoins(state, coins) {
      state.member.coins = coins;
    },
    setSubscriptionType(state, type) {
      state.member.studioAiSubscriptionType = type;
    },
  },
};
